import {Card, Col, Row} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import {IBrandCategory} from "../interface";
import React, {SetStateAction} from "react";
import {PICTURE_URL} from "../../../helpers/api.routes";

interface IProps {
    state: IBrandCategory | null;
    setState: React.Dispatch<SetStateAction<IBrandCategory | null>>;
    setIsMenuOpened: React.Dispatch<React.SetStateAction<boolean>>;
    setImage: React.Dispatch<React.SetStateAction<File | null>>
}

export const CreateForm = ({state, setState, setIsMenuOpened, setImage}: IProps) => {
    const {t} = useTranslation();
    const changeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        const {name, value} = event.target;
        setState((prev: any) => ({...prev, [name]: value}));
    };
    const switchHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setState((prev) => ({...prev, [e.target.name]: e.target.checked}) as IBrandCategory);
    };
    const fileHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.target.files && setImage(e.target.files[0]);
    };
    return (
        <Card>
            <Card.Body>
                <Row>
                    <Col md={4}>
                        <label htmlFor="title" className="required-field">
                            {t("global.title")}
                        </label>
                        <input
                            type="text"
                            name="title"
                            className="form-control"
                            required
                            onChange={changeHandler}
                            value={state?.id && state?.title}
                        />
                    </Col>
                    <Col md={2}>
                        <div className="form-check form-switch p-0">
                            <label
                                className="d-block text-start"
                                htmlFor="activeSwitch"
                            >
                                {t("global.active")}
                            </label>
                            <div className="row">
                                <input
                                    className="form-check-input switch-custom ms-4 mt-2"
                                    type="checkbox"
                                    name={"active"}
                                    checked={state?.active}
                                    onChange={switchHandler}
                                    role="switch"
                                    id="activeSwitch"
                                />
                            </div>
                        </div>
                    </Col>
                    <Col md={12}>
                        <div className="mt-3">
                            <label htmlFor="imageFile"> {t("download.image")}</label>
                            <input
                                onChange={fileHandler}
                                className="form-control"
                                type="file"
                                accept="image/*"
                                id="imageFile"
                            />
                        </div>
                        {state?.image && (
                            <div className="d-flex align-items-center mt-3">
                                <img
                                    className="object-fit-cover"
                                    width={200}
                                    height={200}
                                    src={PICTURE_URL + state?.image.imagePath}
                                    data-holder-rendered="true"
                                    alt={state?.image?.imageName}
                                    style={{margin: '2px'}}
                                />
                            </div>
                        )}
                    </Col>
                </Row>
                <div className="col-12 my-2 d-flex justify-content-end text-align-center">
                    <div>
                        <button
                            className="btn btn-info"
                            type={"button"}
                            onClick={() => {
                                setIsMenuOpened(false);
                                setState(null);
                            }}
                        >
                            {t("global.cancel")}
                        </button>
                        <button className="btn btn-primary ms-3" type="submit">
                            {state?.id ? `  ${t("global.update")}` : `${t("global.create")}`}
                        </button>
                    </div>
                </div>
            </Card.Body>
        </Card>
    );
};
